import React from "react";

export default function SplashScreen({ fadeOut = false }) {
  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background ${fadeOut ? "selec-splash-out" : ""}`}
      data-testid="splash-screen"
    >
      <div className="relative flex items-center justify-center">
        <span className="absolute h-28 w-28 rounded-full border-2 border-primary/40 selec-ring" />
        <span className="absolute h-28 w-28 rounded-full border-2 border-primary/30 selec-ring" style={{ animationDelay: "0.6s" }} />
        <div className="selec-pop relative h-24 w-24 rounded-3xl bg-white shadow-elevated flex items-center justify-center overflow-hidden">
          <img src="/logo-selec.jpg" alt="SELEC ONE 360" className="h-20 w-20 rounded-2xl object-cover" />
        </div>
      </div>

      <div className="selec-fade-up mt-8 text-center" style={{ animationDelay: "0.25s" }}>
        <p className="font-heading font-black text-3xl tracking-tight">
          SELEC <span className="text-primary">ONE 360</span>
        </p>
        <p className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground font-bold mt-2">
          La fuerza detrás de tu producción
        </p>
      </div>

      <div className="selec-fade-up mt-10 h-1 w-44 overflow-hidden rounded-full bg-muted" style={{ animationDelay: "0.4s" }}>
        <div className="h-full w-1/2 rounded-full bg-primary selec-bar" />
      </div>
    </div>
  );
}
